import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-status-input',
    templateUrl: './status-input.component.html',
    standalone: false
})
export class StatusInputComponent {
  @Input() status: string;
}
